var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.48,885.89V194.11h1025.04v691.78H27.48ZM103.61,834.67h872.79l-318.63-267.22-102.88,86.28c-3.91,3.27-9.15,5.08-14.77,5.08-5.75,0-11.15-1.87-15.2-5.26l-102.67-86.1L103.61,834.67ZM701.05,531.15l300.25,251.81v-503.62l-300.25,251.81ZM78.69,782.96l300.26-251.81L78.69,279.34v503.62ZM542.06,591.57l412.86-346.24H129.19l412.87,346.24Z","fillRule":"evenodd"}));
}

Email.defaultProps = {"id":"ICONS","viewBox":"0 0 1080 1080"};

module.exports = Email;

Email.default = Email;
